module.exports = __webpack_public_path__ + "static/projekty-opakowan-hean-18012da02ed435ece8c42e87f7d1c823.jpg";